module.exports = __webpack_public_path__ + "img/learner-quiz-Cougar.3652d840.png";